import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { prepare_description } from 'console/tabs/legacy/opentherm-dialog/opentherm-errcodes-legacy';
import { preventDefault, useCallbacks } from 'shared/hooks/utils';
import { Box, Link } from '@mui/material';
export const OTErrorDescriptionLink = memo(function OTErrorDescriptionLink(props) {
    const { spec, onOpenErrorDialog } = props;
    const onClick = useCallbacks([preventDefault, onOpenErrorDialog]);
    const prepared = prepare_description(spec);
    if (prepared == null) {
        return null;
    }
    const { title, more_title } = prepared;
    if (title != null) {
        if (more_title != null)
            return (_jsxs(Box, { children: [title, _jsx("br", {}), "(", _jsx(Link, { href: "#", onClick: onClick, sx: {
                            color: 'common.white',
                            textDecorationColor: '#fff',
                        }, children: "\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u044B" }), ")"] }));
        return _jsx("span", { children: title });
    }
    return (_jsx(Link, { href: "#", onClick: onClick, sx: {
            color: 'common.white',
            textDecorationColor: 'common.white',
        }, children: "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438" }));
});
